import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import $ from "jquery"; // For jQuery integration
import "./Feedback.css";
import fb from "../image/fd.webp";
import Header from "../Header";
import Footer from "../Footer";
import ScrollButtons from "../ScrollButtons";

const Feedback = () => {
  const [formData, setFormData] = useState({
    name: "",
    message: "",
    rating: 0,
  });

  const [errors, setErrors] = useState({});

  // Handle star rating click
  const handleRatingClick = (value) => {
    setFormData({ ...formData, rating: value });
  };

  // Handle form input change
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
    if (value.trim() !== "") {
      $(`#${id}`).removeClass("is-invalid");
    }
  };

  // Form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = {};

    // Name validation
    if (!formData.name.trim()) {
      validationErrors.name = "Name is required.";
      $("#name").addClass("is-invalid");
    }

    // Feedback message validation
    if (!formData.message.trim()) {
      validationErrors.message = "Feedback message is required.";
      $("#message").addClass("is-invalid");
    }

    setErrors(validationErrors);

    // If no errors, show a success message
    if (Object.keys(validationErrors).length === 0) {
      alert("Thank you for your feedback!");
      setFormData({
        name: "",
        message: "",
        rating: 0,
      });
    }
  };

  return (
    <div>
      <Header />
      <ScrollButtons/>
      <div className="container py-5">
        <div className="row justify-content-center">
          {/* Feedback Form */}
          <div className="col-md-6">
            <div className="feedback-card p-4">
              <img src={fb} alt="Hotel" className="img-fluid imgf" />
              <h3 className="text-center">Hotel Feedback</h3>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleInputChange}
                  />
                  {errors.name && (
                    <div className="invalid-feedback">{errors.name}</div>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="message">Feedback Message</label>
                  <textarea
                    className="form-control"
                    id="message"
                    rows="4"
                    placeholder="Your feedback..."
                    value={formData.message}
                    onChange={handleInputChange}
                  />
                  {errors.message && (
                    <div className="invalid-feedback">{errors.message}</div>
                  )}
                </div>
                <div className="form-group">
                  <label>Rating</label>
                  <div className="star-rating">
                    {[1, 2, 3, 4, 5].map((value) => (
                      <span
                        key={value}
                        className={`star ${
                          formData.rating >= value ? "filled" : ""
                        }`}
                        onClick={() => handleRatingClick(value)}
                      >
                        ★
                      </span>
                    ))}
                  </div>
                </div>
                <button type="submit" className="btn btn-primary btn-block">
                  Submit Feedback
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Feedback;
